// extracted by mini-css-extract-plugin
export default {"mapSwitchers":"styles_mapSwitchers__QSN8R","clientFeedWrapper":"styles_clientFeedWrapper__uBjuY"};